import $ from 'jquery';
import { debounce } from 'lodash';
import Turbolinks from 'javascripts/turbolinks';
import { getSavedCategoriesState, setSavedCategoriesState } from './helpers';
import bindAdvancedForm from './new_theme/form';
import IdeaCommentForm from './idea_comment';

let ideaSearchAjax;

const getParameterByName = function (name) {
  const match = RegExp(`[?&]${name}=([^&]*)`).exec(window.location.search);
  return match && decodeURIComponent(match[1].replace(/\+/g, ' '));
};

$(function () {
  $(document).on('portalUserReady', '.popover.active', function (event, token) {
    if ($(this).hasClass('vote-popover')) {
      $(this)
        .parents('.idea-endorsement')
        .find(`a[data-count="${$(this).data('count')}"]`)
        .click();
    } else if ($(this).hasClass('subscribe-popover')) {
      $(this).parents('.idea-subscription').find('a').click();
    } else if ($(this).hasClass('comment-popover--classic') && token) {
      const form = $(this).parents('.idea-comment-new').find('form');
      form.find("input[name='authenticity_token']").val(token);
      form.submit();
    } else {
      window.location.reload();
    }
  });

  $(document).on('page:change', function () {
    let return_to_action;
    if ((return_to_action = getParameterByName('return_to_action'))) {
      let idea_id, match;
      if ((match = RegExp(/vote_(\d+)/).exec(return_to_action))) {
        idea_id = match[1];
        $(`#idea-${idea_id}-endorsement .btn-vote`).click();
      } else if ((match = RegExp(/subscribe_(\d+)/).exec(return_to_action))) {
        idea_id = match[1];
        $(`#idea-${idea_id}-subscription .btn-subscribe`).click();
      }
    }
  });

  $(document).on('click', '.filters a.category-filter', function (event) {
    const $currentTarget = $(event.currentTarget);
    const href = $currentTarget.attr('href');
    const removeCategory =
      $currentTarget.hasClass('active') &&
      !$('#category-filter').data('multi-category-filter-enabled');
    const sort = getParameterByName('sort');
    const search = getParameterByName('query');
    if (sort || removeCategory || search) {
      event.stopPropagation();
      event.preventDefault();

      const sortRegx = /sort=[^&]+/;
      const idRegx = /category=[^&]+&*/;
      const searchRegx = /query=[^&]+&*/;
      let newHref = href;
      newHref = newHref.replace(sortRegx, '');
      newHref = newHref.replace(searchRegx, '');
      if (sort) {
        newHref = newHref + `&sort=${sort}`;
      }
      if (removeCategory) {
        newHref = newHref.replace(idRegx, '');
      }
      if (search) {
        newHref = newHref + `&query=${search}`;
      }
      window.location = newHref;
    }
  });

  $(document).on('click', 'a[data-remote]', function (event) {
    let href;
    if (!(href = $(event.currentTarget).attr('data-href'))) {
      return;
    }

    event.stopPropagation();
    event.preventDefault();

    $(event.currentTarget).attr('href', href);
    $(event.currentTarget).attr('data-href', null);

    $(event.currentTarget).trigger('click');

    $(event.currentTarget).attr('data-href', href);
    $(event.currentTarget).attr('href', null);
  });

  $(document).on('click', 'html', function (event) {
    // Don't close popover when dismissing alert
    if ($(event.target).data('dismiss') === 'alert') return;

    if (
      $('.popover.active').length > 0 &&
      !$(event.target).hasClass('popover') &&
      $(event.target).parents('.popover').length === 0
    ) {
      $('.popover.active').removeClass('active');
    }
  });

  const debouncedSearch = debounce((url, query) => {
    if (ideaSearchAjax != null && ideaSearchAjax.readyState !== 4) {
      ideaSearchAjax.abort();
    }
    ideaSearchAjax = $.ajax({
      url,
      type: 'POST',
      dataType: 'script',
      data: {
        query: query,
        project_id:
          $('#ideas_idea_project_id').val() || // classic design
          $('#project_id.project-selector').val(), // new design
      },
    });
  }, 250);

  $(document).on(
    'keyup',
    '.public #ideas_idea_name, .private #ideas_idea_name',
    function (event) {
      const $this = $(this);
      const url = $('.found-ideas').attr('data-url');
      if (!url) {
        return;
      }

      debouncedSearch(url, $this.val());
    }
  );

  $(document).on(
    'change',
    '#project_id, #ideas_idea_project_id',
    function (event) {
      const projectId = $(this).val();
      const url = $(this).attr('data-new-idea-url') || document.location.href;

      $('.new-idea-fields').html('');
      if (projectId === '' || projectId === undefined) {
        $('.new-idea-fields-loading').addClass('hide');
      } else {
        $('.new-idea-fields-loading').removeClass('hide');
        $.ajax({
          url,
          type: 'get',
          data: {
            project_id: projectId,
            feedback_jwt: $('meta[name=feedback-jwt]').attr('content'),
          },
          dataType: 'script',
          success() {
            if (window.formElements) {
              bindAdvancedForm(
                'form#new_ideas_idea',
                window.formElements,
                window.formTranslations,
                window.formVisitedSectionIds
              );
            }
          },
        });
      }
    }
  );
  $(document).on('click keydown', '.category-collapser', function (event) {
    if (
      event.type === 'keydown' &&
      event.key !== 'Enter' &&
      event.key !== ' '
    ) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();

    const $category = $(this).parents('li').first();
    const $categoriesList = $category.find('> ul').first();

    const id = $category.attr('id');

    if ($categoriesList.hasClass('categories-collapsed')) {
      $categoriesList.removeClass('categories-collapsed');

      // Classic portal uses fa-angle. New design portal uses fa-chevron.
      if ($(this).hasClass('fa-angle-right')) {
        $(this)
          .removeClass('fa-angle-right')
          .addClass('fa-regular fa-angle-down');
      } else if ($(this).hasClass('fa-chevron-right')) {
        $(this).toggleClass('fa-chevron-right fa-chevron-down');
      }
      $(this).attr('aria-expanded', true);
      setSavedCategoriesState(id);
    } else {
      $categoriesList.addClass('categories-collapsed');
      if ($(this).hasClass('fa-angle-down')) {
        $(this)
          .removeClass('fa-angle-down')
          .addClass('fa-solid fa-angle-right');
      } else if ($(this).hasClass('fa-chevron-down')) {
        $(this).toggleClass('fa-chevron-right fa-chevron-down');
      } else {
        $(this).addClass('fa-solid fa-sort-right');
      }
      $(this).attr('aria-expanded', false);
      setSavedCategoriesState(id, false);
    }

    return false;
  });

  window.IdeaCommentForm = IdeaCommentForm;
});

const expandCategory = function ($item, expandParents = false) {
  const collapser = $item.find('.category-collapser').first();

  // Classic portal uses fa-angle. New design portal uses fa-chevron.
  if (collapser.hasClass('fa-angle-right')) {
    collapser
      .removeClass('fa-angle-right')
      .addClass('fa-regular fa-angle-down');
  } else if (collapser.hasClass('fa-chevron-right')) {
    collapser.toggleClass('fa-chevron-right fa-chevron-down');
  }
  collapser.attr('aria-expanded', true);
  $item.find('> ul').first().removeClass('categories-collapsed');
  setSavedCategoriesState($item.attr('id'));

  if (expandParents) {
    $item.parents('[data-filter-type]').each((index, parent) => {
      expandCategory($(parent));
    });
  }
};

const autoExpandCategories = function (body) {
  const $body = $(body);

  // autoExpandCategories is called on both BEFORE_UNLOAD (to auto-expand before body swap, preventing flicker)
  // and iripo.in (for initial load/AJAX) with same body. Early return prevents wasted work.
  if ($body.data('auto-expand-categories-called')) {
    return;
  }
  $body.data('auto-expand-categories-called', true);

  const savedCategoriesState = getSavedCategoriesState();

  // Remove empty class when not empty, will reveal the collapser icon
  $body.find('.category-collapser--empty').each((_, node) => {
    const $node = $(node);
    if ($node.closest('li').find('li').length > 0) {
      $node.removeClass('category-collapser--empty');
    }
  });

  // Auto-expand entire category tree if number of nodes is small
  if ($body.find('.category-collapser').length <= 20) {
    $body
      .find('.category-collapser:not(.category-collapser--empty)')
      .each((_, collapser) => {
        const $li = $(collapser).closest('li');

        // Auto-expand if not explicitly collapsed via false in saved state
        if (savedCategoriesState[$li.attr('id')] !== false) {
          expandCategory($li);
        }
      });
  } else {
    // Auto-expand category tree nodes per saved state
    Object.entries(savedCategoriesState).forEach(([key, value]) => {
      if (value) {
        expandCategory($body.find(`#${key}`));
      }
    });
  }

  // Auto-expand each filtered category and project so you can see them
  const url = new URL(document.location.href);
  const category = url.searchParams.get('category');
  if (category) {
    category.split(',').forEach(categoryId => {
      expandCategory($body.find(`#category-${categoryId.trim()}`), true);
    });
  }
  const project = url.searchParams.get('project');
  if (project) {
    project.split(',').forEach(projectRef => {
      expandCategory(
        $body.find(
          `[data-filter-type="project"][data-project-ref='${projectRef.trim()}']`
        ),
        true
      );
    });
  }
};

iripo.in('.portal-sidebar .categories.filters', function (_node) {
  autoExpandCategories(document.body);

  $('.vote').tooltip({});
});

$(document).on(Turbolinks.EVENTS.BEFORE_UNLOAD, event => {
  autoExpandCategories(event.originalEvent.data.newBody);
});

// Handle closing bootstrap modals when the custom event is fired.
window.addEventListener('aha-modal-header:close', event => {
  if (event.defaultPrevented) return;
  const target = event.target;
  if (target instanceof HTMLElement) {
    const modal = target.closest('.modal');
    if (modal) {
      $(modal).modal('hide');
    }
  }
});
